module.exports = __webpack_public_path__ + "static/media/ic_fontcolor.3245485c.svg";